import { Centro, PilaV, Texto } from '@/components/atomos';
import { anchoMaximo } from '@/styles/constants';
import { Heading } from '@chakra-ui/react';

const HeaderAviso = ({
  titulo,
  subtitulo,
}: {
  titulo: string;
  subtitulo: string;
}) => {
  return (
    <Centro minW={'full'} className='fondo-marca' h={'200px'}>
      <PilaV
        maxW={anchoMaximo}
        w={'full'}
        alignItems={'start'}
        p={4}
        animation={'fadeIn 250ms forwards'}
      >
        <Heading color={'layout'}>{titulo}</Heading>
        <Texto fontSize={'md'} fontWeight={'semibold'}>
          {subtitulo}
        </Texto>
      </PilaV>
    </Centro>
  );
};

export default HeaderAviso;
